import React, { useEffect, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Graphics } from '@pixi/react';
import { isMobile } from '../../../core/helpers/isMobile';
import GameBoard from '../../../components/common/gameBoard';
import { reelContainerParams, symbolSizes } from '../../../core/constants/reelConstants';

const GameBoardWrapper = observer(
  ({ setMask, winContainerRef, reelContainerRef, touchSpinScreenRef, reelContainerConfig }) => {
    const gameBoardSlotRef = useRef(null);
    const gameBoardContainerRef = useRef(null);

    const { containerConfig } = useMemo(() => {
      return {
        containerConfig: {
          x: isMobile() ? 269.5 : 719.5,
          y: isMobile() ? 406 : 393,
        },
      };
    }, []);

    useEffect(() => {
      if (gameBoardContainerRef.current && gameBoardSlotRef.current) {
        gameBoardContainerRef.current.children[0].addChildToSlot('board', gameBoardSlotRef.current);
      }
    }, []);

    return (
      <>
        <Container ref={gameBoardSlotRef}>
          <Container ref={reelContainerRef} {...reelContainerConfig} name='ReelContainer'>
            <Graphics
              draw={(g) => {
                g.beginFill(0xff700b);
                g.drawRect(
                  -symbolSizes.width / 2 + reelContainerParams.offsetForContainerBoardWidth,
                  -symbolSizes.height / 2 + reelContainerParams.offsetForContainerBoardHeight,
                  reelContainerParams.width - 2 * reelContainerParams.offsetForContainerBoardWidth,
                  reelContainerParams.height - 2 * reelContainerParams.offsetForContainerBoardHeight
                );
              }}
              ref={(graphicsRef) => setMask(graphicsRef)}
            />
          </Container>
          <Container ref={winContainerRef} {...reelContainerConfig} name='WinContainer' />
        </Container>

        <GameBoard
          containerConfig={containerConfig}
          gameBoardContainerRef={gameBoardContainerRef}
        />
      </>
    );
  }
);

export default GameBoardWrapper;
